var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmptyDm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F5F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5859 70.3477C37.9297 70.3477 43.7695 67.7891 47.0898 65.4258C47.4219 65.1719 47.6953 65.0742 47.9688 65.0742C48.2227 65.1133 48.4766 65.1133 48.7305 65.1133C62.8125 65.1133 72.1484 57.1055 72.1484 47.3789C72.1484 37.5547 62.3047 29.625 50 29.625C37.6953 29.625 27.8516 37.5547 27.8516 47.3789C27.8516 53.6484 31.6992 59.1367 37.9688 62.4766C38.2617 62.6328 38.3594 62.9258 38.2031 63.2383C37.1094 65.0352 35.1562 67.1836 34.4141 68.1602C33.6523 69.1367 34.082 70.3477 35.5859 70.3477Z",
    fill: "#0E2B89",
    fillOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyDm);
export default __webpack_public_path__ + "static/media/icon-empty-dm.e17e9830baeba5ce1251366495c49751.svg";
export { ForwardRef as ReactComponent };